import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 17.5,
	viewBox: "0 0 24 17.5",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "#fff",
		strokeMiterlimit: 10,
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m0 8.846h24" }),
			/* @__PURE__ */ _jsx("path", { d: "m0 16.75h24" }),
			/* @__PURE__ */ _jsx("path", { d: "m0 .75h24" })
		]
	})
});
export default SvgMenu;
